import zhCNLocales from '@/locales/zh_cn_locales'

const locales = {
  'zh-CN': zhCNLocales
}

export { locales as default }
